module.exports = __webpack_public_path__ + "static/media/392.e9b57541.svg";